import { render } from "./ChamparanEliteTouch.vue?vue&type=template&id=4803cfdc&scoped=true"
import script from "./ChamparanEliteTouch.vue?vue&type=script&lang=js"
export * from "./ChamparanEliteTouch.vue?vue&type=script&lang=js"

import "./ChamparanEliteTouch.vue?vue&type=style&index=0&id=4803cfdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4803cfdc"]])

export default __exports__